import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent implements OnChanges, AfterViewInit {
    @ViewChild('progressBar') progressBar!: ElementRef;
    @Input() progress: number = 0;

    private isViewInitialized = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['progress'] && this.isViewInitialized) {
            this.setProgressCSS(this.progress);
        }
    }

    ngAfterViewInit(): void {
        this.isViewInitialized = true;
        this.setProgressCSS(this.progress);
    }

    private setProgressCSS(progress: number): void {
        if (progress <= 0) {
            progress = 0;
        }

        if (progress >= 100) {
            progress = 100;
        }

        this.progress = progress;

        if (this.progressBar && this.progressBar.nativeElement) {
            this.progressBar.nativeElement.style.setProperty('--width', `${progress}%`);
        }
    }
}
